import React from 'react';

const burgerEmojis = new Set(['✊', '💘', '🍌', '🍑', '🍆', '📢']);

export function getOrgasmeatEmoji(name = '') {
  const first = Array.from(name.trim())[0];
  return burgerEmojis.has(first) ? first : '';
}

export function getOrgasmeatDisplayName(name = '') {
  const emoji = getOrgasmeatEmoji(name);
  return emoji ? name.trimStart().slice(emoji.length).replace(/^[\uFE0E\uFE0F]?\s*/u, '') : name;
}

export default function OrgasmeatEmoji({ name, className = '' }) {
  const emoji = getOrgasmeatEmoji(name);
  return emoji ? <span className={`orgasmeat-emoji ${className}`} aria-hidden="true">{emoji}</span> : null;
}
